import { createFeatureSelector } from '@ngrx/store';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { FollowUpActions, FollowUpActionTypes } from '../_actions/follow-up.actions';
import { FollowUpModel } from '../_models/follow-up.model';
import { QueryParamsModel } from '../../_base/crud';

export interface FollowUpState extends EntityState<FollowUpModel> {
  listLoading: boolean;
  actionsloading: boolean;
  totalCount: number;
  lastCreatedFollowUpId: number;
  lastQuery: QueryParamsModel;
  error: any;
  showInitWaitingMessage: boolean;
}

export const adapter: EntityAdapter<FollowUpModel> = createEntityAdapter<FollowUpModel>();

export const initialFollowUpState: FollowUpState = adapter.getInitialState({
  listLoading: false,
  actionsloading: false,
  totalCount: 0,
  error: null,
  lastQuery: new QueryParamsModel({}),
  lastCreatedFollowUpId: undefined,
  showInitWaitingMessage: true,
});

export function followUpReducer(
  state = initialFollowUpState,
  action: FollowUpActions,
): FollowUpState {
  switch (action.type) {
    case FollowUpActionTypes.FollowUpPageToggleLoading:
      return {
        ...state,
        listLoading: action.payload.isLoading,
        lastCreatedFollowUpId: undefined,
      };
    case FollowUpActionTypes.FollowUpActionToggleLoading:
      return {
        ...state,
        actionsloading: action.payload.isLoading,
      };
    case FollowUpActionTypes.FollowUpPageCancelled:
      return {
        ...state,
        listLoading: false,
        lastQuery: new QueryParamsModel({}),
      };
    case FollowUpActionTypes.FollowUpPageLoaded: {
      return adapter.addMany(action.payload.followUp, {
        ...initialFollowUpState,
        totalCount: action.payload.totalCount,
        lastQuery: action.payload.page,
        listLoading: false,
        showInitWaitingMessage: false,
      });
    }

    case FollowUpActionTypes.ThrowFollowUpError: {
      return {
        ...state,
        error: action.payload.error,
        actionsloading: false,
        listLoading: false,
      };
    }
    case FollowUpActionTypes.ClearFollowUpErrors: {
      return {
        ...state,
        error: null,
      };
    }
    default:
      return state;
  }
}

export const getFollowUpState = createFeatureSelector<FollowUpState>('followUp');

export const { selectAll, selectEntities, selectIds, selectTotal } = adapter.getSelectors();
